import { Level } from '../entities/exercise';

export interface ISkillLevelWithDescription {
    level: Level;
    description: string;
}

export class SkillLevelConfig {
    public static skillLevelWithDescription: ISkillLevelWithDescription[] = [{
        level: Level.Beginner,
        description: 'If you\'ve never trained before or been out of action for a long time ' +
        'this level is the right place to start turning back the clock.',
    }, {
        level: Level.Basic,
        description: 'If you\'ve been in and out of the gym over the last few months and you\'re ' +
        'just off the pace of hard-core training, this level will get you up to speed.',
    }, {
        level: Level.Intermediate,
        description: 'If you\'ve been training for a while and you back your strength and fitness, ' +
        'this level will challenge you with hard-core workouts.',
    }];
}
